import translate from "components/translations/translations.wrapper";
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";
import { Tooltip } from "components/tooltip/Tooltip";
import { SHARED_TOOLTIP_ID } from "components/tooltip/AppTooltip.component";

export const LinkToHelpCenter = ({ translate }) => {
    const helpCenterReplacementUrl = window.ENVIRONMENT?.HELP_CENTER_URL;
    return (
        <li className="icon" data-tip="menu-help-center-tooltip" data-for={SHARED_TOOLTIP_ID}>
            <a className="button-help" target="tab-helpcenter" rel="noopener noreferrer" aria-label={translate("menu.helpBoxReplacement.label")} href={helpCenterReplacementUrl}>
                <CircleQuestionMark size={ICON_SIZE.MEDIUM} aria-hidden="true" />
                <span className="notificationBadge badge" />
            </a>
            <Tooltip id="menu-help-center-tooltip" content={() => translate("menu.helpBoxReplacement.label")} />
        </li>
    );
};

export default translate(LinkToHelpCenter);